(function () {
  'use strict';

  /* Sync a variant ID into Shopify's native hidden/select inputs —
     but ONLY inside Koala's own widget containers. Never touch
     document-wide inputs: a product page can have several unrelated
     name="id" fields (main product form, quick-add modals, other
     upsell widgets), and a global querySelector would silently
     overwrite the WRONG form's variant — causing the main "Add to
     cart" button to submit a different product/color than the
     customer actually selected. */
  function getKoalaContainers() {
    return [
      document.getElementById('koala_upsell_widget'),
      document.getElementById('koala-bundle-widget'),
      document.querySelector('[data-koala-widget]'),
      document.querySelector('[id^="koala"]'),
      document.querySelector('[class*="koala-upsell"]')
    ].filter(Boolean);
  }

  function syncVariant(variantId) {
    var id = parseInt(variantId, 10);
    if (!id || isNaN(id)) return;

    var containers = getKoalaContainers();
    if (!containers.length) return;

    containers.forEach(function (container) {
      /* Classic themes use <select name="id"> */
      var selectEl = container.querySelector('select[name="id"]');
      if (selectEl && selectEl.value != id) {
        selectEl.value = id;
        selectEl.dispatchEvent(new Event('change', { bubbles: true }));
      }

      /* OS 2.0 / custom themes use <input type="hidden" name="id"> */
      var inputEl = container.querySelector('input[name="id"]');
      if (inputEl && inputEl.value != id) {
        inputEl.value = id;
        inputEl.dispatchEvent(new Event('change', { bubbles: true }));
      }
    });

    /* Custom event — scoped consumers can still listen for this */
    document.dispatchEvent(new CustomEvent('variant:changed', {
      bubbles: true,
      detail: { variant: { id: id } }
    }));
  }

  /* ── Listen for Koala's custom events ──────────────────────────────── */
  document.addEventListener('koala:variant-selected', function (e) {
    var vid = e.detail && (e.detail.variantId || e.detail.variant_id);
    if (vid) syncVariant(vid);
  });

  document.addEventListener('koala:add-to-cart', function (e) {
    var vid = e.detail && (e.detail.variantId || e.detail.variant_id);
    if (vid) syncVariant(vid);
  });

  /* Koala sometimes uses generic names — cover extra aliases */
  document.addEventListener('koala:selection-change', function (e) {
    var vid = e.detail && (e.detail.variantId || e.detail.variant_id);
    if (vid) syncVariant(vid);
  });

  /* ── MutationObserver fallback ──────────────────────────────────────
     Watches for any Koala-rendered <select> or hidden <input> changes
     inside common Koala container selectors. */
  var observer = new MutationObserver(function () {
    /* Koala renders inside an element with id="koala-bundle-widget"
       or a data attribute — try both common patterns */
    var containers = [
      document.getElementById('koala-bundle-widget'),
      document.querySelector('[data-koala-widget]'),
      document.querySelector('[id^="koala"]'),
      document.querySelector('[class*="koala-upsell"]')
    ];

    for (var i = 0; i < containers.length; i++) {
      var c = containers[i];
      if (!c) continue;
      /* Look for a hidden variant input or select inside Koala */
      var hiddenInput = c.querySelector('input[name="id"], input[name="variant_id"], input[type="hidden"][value]');
      if (hiddenInput && hiddenInput.value) {
        syncVariant(hiddenInput.value);
        return;
      }
      var koalaSelect = c.querySelector('select[name="id"]');
      if (koalaSelect && koalaSelect.value) {
        syncVariant(koalaSelect.value);
        return;
      }
    }
  });

  /* Start observing once the DOM is ready */
  function startObserver() {
    /* Try to find Koala's container; if not found yet, observe body */
    var target = document.getElementById('koala-bundle-widget')
      || document.querySelector('[data-koala-widget]')
      || document.body;
    observer.observe(target, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['value']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', startObserver);
  } else {
    startObserver();
  }

})();
